import { required } from "react-admin";
import { RaDriverPicker } from "../../common/form/RaDriverPicker";

interface Props {
  isEdit?: boolean;
}

export const DriverAndCoDriverInput = (props: Props) => {
  const { isEdit, ...rest } = props;
  return (
    <div className="two-inputs-container">
      <RaDriverPicker
        {...rest}
        source="driverId"
        label="Driver"
        validate={required()}
        disabled={isEdit}
      />
      <RaDriverPicker {...rest} source="coDriverId" label="Co-driver" />
    </div>
  );
};
